<script>
  export let title;
  export let subtitle = "";
  export let tipe = "1";
  export let href = "";
</script>

{#if tipe == "1"}
  <div class="p-2 px-5 my-2 bg-gray-100 rounded-lg shadow">
    <h2 class="text-lg">{title}</h2>
    {#if subtitle}
      <p class="text-sm text-gray-700">{subtitle}</p>
    {/if}
  </div>
{:else if tipe == "2"}
  <div class="p-2 px-5 my-5 mb-2 bg-gray-100 rounded-lg shadow">
    <h2 class="text-xl">{title}</h2>
    {#if subtitle}
      <p class="text-sm text-gray-700">{subtitle}</p>
    {/if}
  </div>
{:else}
  <header
    class="flex flex-col items-center p-2 px-5 py-2 my-5 mb-2 text-center bg-gray-100 rounded-md shadow lg:flex-row lg:text-left lg:mt-4"
  >
    {#if href !== ""}
      <a
        {href}
        class="px-3 bg-gray-100 rounded-md shadow text-md hover:bg-gray-200 lg:px-3 md:px-0"
      >
        #{title}
      </a>
    {:else}
      <span
        class="px-3 bg-gray-100 rounded-md shadow text-md hover:bg-gray-200 lg:px-3 md:px-0"
      >
        #{title}
      </span>
    {/if}
    {#if subtitle}
      {#if href !== ""}
        <a {href} class="hidden ml-auto text-sm text-gray-700 lg:block">
          {subtitle}
        </a>
      {:else}
        <span class="hidden ml-auto text-sm text-gray-700 lg:block">
          {subtitle}
        </span>
      {/if}
    {/if}
  </header>
{/if}
